import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd-mobile';
import { useTranslation } from 'react-i18next';
import enUS from 'antd-mobile/es/locales/en-US';
import zhCN from 'antd-mobile/es/locales/zh-CN';
import { App } from './App';
import './styles/global.css';
// Side-effect import: triggers i18next initialization before any component
// using `useTranslation` is mounted.
import './i18n';

// antd-mobile does not officially ship a Bengali locale, so we fall back to
// `en-US` for component-level strings (e.g. picker confirm labels). All
// product copy is still translated via i18next resources.
const ANTD_MOBILE_LOCALES: Record<string, typeof enUS> = {
  'zh-CN': zhCN,
  'en-US': enUS,
  'bn-BD': enUS,
};

// Wrap the app once i18n is bootstrapped so antd-mobile's locale stays in
// sync with the user's selected language.
const LocalizedApp: React.FC = () => {
  const { i18n } = useTranslation();
  const locale = ANTD_MOBILE_LOCALES[i18n.language] ?? enUS;
  return (
    <ConfigProvider locale={locale}>
      <App />
    </ConfigProvider>
  );
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      {/* Suspense fallback while the initial namespace JSON is being fetched */}
      <Suspense fallback={null}>
        <LocalizedApp />
      </Suspense>
    </BrowserRouter>
  </React.StrictMode>
);
